module.exports = __webpack_public_path__ + "img/top_catch.0ff3b298.jpg";